<template>
  <invoice-list-page invoice-type="local" />
</template>

<script>
import InvoiceListPage from '../../internal/internal-list/InvoicesList.vue'

export default {
  name: 'LocalInvoiceList',
  components: {
    InvoiceListPage,
  },
}
</script>
